import { Dispatch } from 'redux';
import * as LoginActions from '../actions/login';
import * as MessageActions from '../actions/message';

import Transfers from '../utils/Transfers';

const showProgress = () =>
	LoginActions.showLoginProgress({
		isShowProgress: true,
	});
const hideProgress = () =>
	LoginActions.showLoginProgress({
		isShowProgress: false,
	});

export const fetch = (dispatch: Dispatch, companyCode: string) => {
	dispatch(showProgress());
	return Transfers.samlStart(companyCode).then(data => {
		if (data.location) {
			window.location = data.location;
			return;
		}
		dispatch(hideProgress());
		dispatch(
			MessageActions.showMessage({
				messages: [
					{
						content: data.messageKey,
					},
				],
				title: data.titleKey,
			})
		);
	});
};



// WEBPACK FOOTER //
// ./src/scenario/loginSsosp.ts